import JForm from './src/JForm';

const Form = {
    install: function (Vue) {
        Vue.component(JForm.name, JForm);
    }
};

export default Form;



// WEBPACK FOOTER //
// ./packages/form/index.js